// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* 防止触摸选择和长按菜单影响滑动 */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}

html, body, #root {
  /* 只防止横向的过度滚动，允许纵向滚动传递 */
  overscroll-behavior-x: contain;
  overscroll-behavior-y: auto;
  /* 防止页面被拖拽 */
  touch-action: pan-x pan-y;
  /* 禁用 iOS 橡皮筋效果 - 仅横向 */
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

#root {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

body {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 链接样式 */
a {
  text-decoration: none;
  color: inherit;
}

/* 表格悬停效果 */
.MuiTableRow-root:hover {
  transition: background-color 0.2s ease-in-out;
}

/* 卡片悬停效果 */
.MuiCard-root {
  transition: transform 0.3s, box-shadow 0.3s;
}

.MuiCard-root:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,6DAA6D;EAC7D,iBAAiB;AACnB;;AAEA;EACE;aACW;AACb;;AAEA,WAAW;AACX;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,SAAS;AACT;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  /* 防止触摸选择和长按菜单影响滑动 */\r\n  -webkit-tap-highlight-color: transparent;\r\n  -webkit-touch-callout: none;\r\n}\r\n\r\nhtml, body, #root {\r\n  /* 只防止横向的过度滚动，允许纵向滚动传递 */\r\n  overscroll-behavior-x: contain;\r\n  overscroll-behavior-y: auto;\r\n  /* 防止页面被拖拽 */\r\n  touch-action: pan-x pan-y;\r\n  /* 禁用 iOS 橡皮筋效果 - 仅横向 */\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n#root {\r\n  position: relative;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\nbody {\r\n  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n  min-height: 100vh;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* 自定义滚动条 */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #888;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #555;\r\n}\r\n\r\n/* 链接样式 */\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n/* 表格悬停效果 */\r\n.MuiTableRow-root:hover {\r\n  transition: background-color 0.2s ease-in-out;\r\n}\r\n\r\n/* 卡片悬停效果 */\r\n.MuiCard-root {\r\n  transition: transform 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.MuiCard-root:hover {\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* 动画效果 */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.fade-in {\r\n  animation: fadeIn 0.5s ease-out;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
